module.exports = __webpack_public_path__ + "images/2_old2b427e473436e1af0b09d3d59111a9ee6.svg";